module.exports = __webpack_public_path__ + "img/lg_ring_0_0_null_0.4dc450a0.png";